import { render } from "./Widgets.vue?vue&type=template&id=0c5ba0fb"
import script from "./Widgets.vue?vue&type=script&setup=true&lang=js"
export * from "./Widgets.vue?vue&type=script&setup=true&lang=js"

import "./Widgets.vue?vue&type=style&index=0&id=0c5ba0fb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tools/Widgets.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c5ba0fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c5ba0fb', __exports__)) {
    api.reload('0c5ba0fb', __exports__)
  }
  
  module.hot.accept("./Widgets.vue?vue&type=template&id=0c5ba0fb", () => {
    api.rerender('0c5ba0fb', render)
  })

}


export default __exports__